module.exports = __webpack_public_path__ + "img/swipe-show.cacc5cb7.png";